// import {GLOBAL} from "../../constants/constants";

const request = function (type, url, body, content_type = 'application/json') {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.onload = function () {
            if (this.status === 200) {
                resolve(this.response);
            } else {
                reject(this);
            }
        };
        request.onerror = function () {
            reject(this);
        };
        request.open(type, url);
        request.setRequestHeader('Content-Type', content_type);
        request.send(body || null);
    });
};

export default {
    request
}